import Router from './router';
import Store from '@/store/';
import { SOURCES_CONFIG } from '@/config/variables';
import { ss } from '@/utils/storage';
import _ from 'lodash';
import { reqFetchUserInfo } from '@/api/source';
import { Message as ElMessage } from 'element-ui';

/**
 * 过滤路由数组得到适用于导航栏的路由
 */
const filterNavRoutes = routes => {
  const availableRoutes = [];
  routes.map(route => {
    if (route.meta && route.meta.inNav) {
      if (route.children) {
        route.children = filterNavRoutes(route.children);
      }
      availableRoutes.push(route);
    }
  });
  return availableRoutes;
};

/**
 * 清除 vuex 中的缓存
 */
const clearCache = async () => {
  await Store.dispatch('source/storeCurrentSource', null);
  await Store.dispatch('source/storeSourceInfo', null);
  await Store.dispatch('source/storeNavigators', []);
};

Router.beforeEach(async (to, from, next) => {
  /**
   * 用户 token 相关功能
   */
  // 判断是否已经缓存了 token，未缓存则执行 if 内的动作
  if (!Store.state.user.token) {
    // 如果没有获取到则尝试从 ls 中取到 token
    const tokenOfLs = localStorage.getItem('token');
    if (tokenOfLs) {
      // 如果从 ls 中获取到，则存入 vuex
      await Store.dispatch('user/storeUserToken', tokenOfLs);
    } else {
      // 判断前端是否支持取不到 token 自动重定向到登录页
      location.replace('/login');
      return;
    }
  }

  /**
   * 以 /console 开头的数据库控制台页面
   */
  if (to.path.startsWith('/console')) {
    // 没有存入数据源相关信息，则进行初始化
    if (!Store.state.source.currentSource) {
      // 判断要进入的页面是否带有 token，或者能否通过 token 取到数据源信息
      // 如果没有 token 或者 取不到数据源信息，则跳转到导航页
      const sourceInfo = ss.get(to.query.db_sign);
      if (!to.query.db_sign || !sourceInfo) {
        ElMessage.warning('数据库标识已失效，请重新登录');
        next({ name: 'Navigator' });
        return;
      }

      // 如果取的到，则将信息填入 vuex 中
      // 存入当前数据源标识到 vuex
      await Store.dispatch('source/storeCurrentSource', sourceInfo.mark);
      // 将数据源信息存入 vuex
      await Store.dispatch('source/storeSourceInfo', sourceInfo);
      // 将导航栏路由存入 vuex
      await Store.dispatch(
        'source/storeNavigators',
        filterNavRoutes(SOURCES_CONFIG[sourceInfo.mark].routes)
      );
    }
  }

  /**
   * 如果是从一种数据库跳转到另一种数据库，则强制跳转到导航页
   */
  const fromDatabaseType = _.get(from, 'meta.databaseType');
  const toDatabaseType = _.get(to, 'meta.databaseType');
  if (fromDatabaseType && toDatabaseType && fromDatabaseType !== toDatabaseType) {
    await clearCache();
    location.href = '/#/navigator';
    location.reload();
    return;
  }

  /**
   * 如果从/console 开头的数据库页面跳转到登录页面
   */
  if (to.name === 'Login') {
    if ( !to.query.RegionId || !to.query.instanceName ||
      !to.query.InstanceId || !to.query.ServicePort || !to.query.ServiceType)
    {
      next({ name: 'Navigator' });
      return;
    }
  }

  /**
   * 如果进入 navigator 页面，则需要清空之前的数据源信息
   */
  if (from.path.startsWith('/console') && (to.name === 'Navigator' || to.name === 'Login')) {
    await clearCache();
  }

  /**
   * 加载用户信息
   */
  if (!Store.state.user.userInfo) {
    // 没有加载用户信息，尝试从 ls 中获取
    //const userInfo = localStorage.getItem('user');
    try {
      const res = await reqFetchUserInfo();
      const userInfo = res.data.data;
      if (userInfo) {
        await Store.dispatch('user/storeUserInfo', userInfo);
      } else {
        // 强制重定向到登录页
        location.replace('/login');
        return;
      }
    } catch (e) {
      throw new Error('获取用户信息失败');
    }
  }

  /**
   * 设置页面标题
   */
  document.title =
    _(to.matched)
      .map(item => _.get(item, 'meta.title'))
      .compact()
      .last() || 'Unidata DMS';

  next();
});

Router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default Router;
